import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from '@ant-design/compatible';
import Button from '../../../../../../components/Button';
import { asyncSimpleModal } from '../../../../../../lib/common';
import HomeSubSaveInfo from '../../../sub/save/HomeSubSaveInfo';
import { widgetActions } from '../../../../../../store/modules/widget';
import './HomeWidgetInfo.scss';

const HomeWidgetInfo = (props) => {
  const { form, widgetPageInfo, originalWidgetPageInfo, setData } = props;
  const [isEditable, setEditable] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, async (err) => {
      if (err) return;

      const confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '페이지 내용 변경',
        message: '변경한 사항을 저장하시겠습니까?',
      });

      if (!confirmResult) return;

      dispatch(
        widgetActions.editSubPage({
          id: widgetPageInfo.id,
          title: widgetPageInfo.title,
          memo: widgetPageInfo.memo,
        }),
      );

      setEditable(false);
    });
  }, [widgetPageInfo, dispatch, form]);

  const onCancel = useCallback(async () => {
    form.setFieldsValue({
      title: originalWidgetPageInfo.title,
      memo: originalWidgetPageInfo.memo,
    });

    setData({
      path: ['pageWidgetList', 'widgetPageInfo'],
      value: originalWidgetPageInfo,
    });
    setEditable(false);
  }, [form, originalWidgetPageInfo, setData]);

  return (
    <HomeSubSaveInfo
      className={'home-widget-info'}
      form={form}
      isEditable={isEditable}
      setData={(data) =>
        setData({
          path: ['pageWidgetList', 'widgetPageInfo', ...data.path],
          value: data.value,
        })
      }
      pageInfo={widgetPageInfo}
      rightSide={
        <div className="home-info-management-section">
          {isEditable ? (
            <>
              <Button isRadius color="primary" text="저장" onClick={onSubmit} />

              <Button isRadius color="light" text="취소" onClick={onCancel} />
            </>
          ) : (
            <Button isRadius color="primary" text="편집" onClick={() => setEditable(true)} />
          )}
        </div>
      }
    />
  );
};

export default Form.create({})(HomeWidgetInfo);
